import { useState } from "react";
import { createPortal } from "react-dom";
import { updateOfficeExpenseApi } from "../../app/api";

export default function EditExpenseModal({
  expense,
  categories,
  onClose,
  onUpdated,
}) {
  const [form, setForm] = useState({
    expense_category_id: expense.expense_category_id,
    amount: expense.amount,
    purpose: expense.purpose || "",
    purchase_date: expense.purchase_date?.split("T")[0],
  });

  const [bill, setBill] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) =>
      fd.append(k, v)
    );
    if (bill) fd.append("bill", bill);

    const res = await updateOfficeExpenseApi(
      expense.id,
      fd
    );

    setLoading(false);

    if (res.success) {
      onUpdated();
    } else {
      alert("Update failed");
    }
  };

  // return createPortal(
  //   <>
  //     {/* Overlay */}
  //     <div
  //       className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[3000]"
  //       onClick={onClose}
  //     />

  //     {/* Modal */}
  //     <div className="fixed inset-0 z-[3001] flex justify-center items-center px-4">
  //       <div className="
  //         w-full max-w-md
  //         bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
  //         text-white rounded-2xl p-6 shadow-2xl
  //       ">
  //         <h3 className="text-xl font-semibold mb-4">
  //           Edit Expense
  //         </h3>

  //         <form
  //           onSubmit={handleSubmit}
  //           className="space-y-3"
  //         >
  //           <select
  //             value={form.expense_category_id}
  //             onChange={(e) =>
  //               setForm({
  //                 ...form,
  //                 expense_category_id: e.target.value,
  //               })
  //             }
  //             className="w-full px-3 py-2 rounded-lg bg-white/10"
  //           >
  //             {categories.map((c) => (
  //               <option
  //                 key={c.id}
  //                 value={c.id}
  //                 className="text-black"
  //               >
  //                 {c.name}
  //               </option>
  //             ))}
  //           </select>

  //           <input
  //             type="number"
  //             value={form.amount}
  //             onChange={(e) =>
  //               setForm({
  //                 ...form,
  //                 amount: e.target.value,
  //               })
  //             }
  //             className="w-full px-3 py-2 rounded-lg bg-white/10"
  //             placeholder="Amount"
  //           />

  //           <input
  //             type="date"
  //             value={form.purchase_date}
  //             onChange={(e) =>
  //               setForm({
  //                 ...form,
  //                 purchase_date: e.target.value,
  //               })
  //             }
  //             className="w-full px-3 py-2 rounded-lg bg-white/10"
  //           />

  //           <textarea
  //             value={form.purpose}
  //             onChange={(e) =>
  //               setForm({
  //                 ...form,
  //                 purpose: e.target.value,
  //               })
  //             }
  //             rows={3}
  //             className="w-full px-3 py-2 rounded-lg bg-white/10"
  //             placeholder="Purpose"
  //           />

  //           <input
  //             type="file"
  //             onChange={(e) => setBill(e.target.files[0])}
  //             className="w-full text-sm"
  //           />

  //           <div className="flex justify-end gap-3 pt-3">
  //             <button
  //               type="button"
  //               onClick={onClose}
  //               className="px-4 py-2 rounded-lg bg-white/10"
  //             >
  //               Cancel
  //             </button>

  //             <button
  //               type="submit"
  //               disabled={loading}
  //               className="px-4 py-2 rounded-lg bg-purple-600"
  //             >
  //               {loading ? "Saving..." : "Update"}
  //             </button>
  //           </div>
  //         </form>
  //       </div>
  //     </div>
  //   </>,
  //   document.body
  // );





  return createPortal(
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999]"
        onClick={onClose}
      />
  
      {/* Modal */}
      <div className="fixed inset-0 z-[10000] flex justify-center items-center px-4">
        <div
          className="
          w-full max-w-md
          bg-white/10 backdrop-blur-xl
          border border-white/20
          rounded-2xl
          shadow-2xl
          text-white
          overflow-hidden
        "
        >
          {/* Header */}
          <div className="px-6 py-4 bg-gradient-to-r from-[#2d1c6a] to-[#24155a]">
            <h3 className="text-lg font-semibold">
              Edit Expense
            </h3>
          </div>
  
          {/* Body */}
          <form
            onSubmit={handleSubmit}
            className="p-6 space-y-4"
          >
            <select
              value={form.expense_category_id}
              onChange={(e) =>
                setForm({
                  ...form,
                  expense_category_id: e.target.value,
                })
              }
              className="
                w-full px-4 py-2 rounded-lg
                bg-white/10 border border-white/20
                focus:outline-none focus:ring-2 focus:ring-purple-500/40
              "
            >
              {categories.map((c) => (
                <option
                  key={c.id}
                  value={c.id}
                  className="text-black"
                >
                  {c.name}
                </option>
              ))}
            </select>
  
            <input
              type="number"
              value={form.amount}
              onChange={(e) =>
                setForm({
                  ...form,
                  amount: e.target.value,
                })
              }
              className="
                w-full px-4 py-2 rounded-lg
                bg-white/10 border border-white/20
                focus:outline-none focus:ring-2 focus:ring-purple-500/40
              "
              placeholder="Amount"
            />
  
            <input
              type="date"
              value={form.purchase_date}
              onChange={(e) =>
                setForm({
                  ...form,
                  purchase_date: e.target.value,
                })
              }
              className="
                w-full px-4 py-2 rounded-lg
                bg-white/10 border border-white/20
                focus:outline-none focus:ring-2 focus:ring-purple-500/40
              "
            />
  
            <textarea
              value={form.purpose}
              onChange={(e) =>
                setForm({
                  ...form,
                  purpose: e.target.value,
                })
              }
              rows={3}
              className="
                w-full px-4 py-2 rounded-lg
                bg-white/10 border border-white/20
                focus:outline-none focus:ring-2 focus:ring-purple-500/40
              "
              placeholder="Purpose"
            />
  
            <input
              type="file"
              onChange={(e) => setBill(e.target.files[0])}
              className="w-full text-sm text-white/80"
            />
  
            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-5 py-2 rounded-lg bg-white/10"
              >
                Cancel
              </button>
  
              <button
                type="submit"
                disabled={loading}
                className="px-5 py-2 rounded-lg bg-purple-600 hover:bg-purple-500"
              >
                {loading ? "Saving..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>,
    document.body
  );
  



}
